var magicStyles = [".picture[data-v-50573ab2],\n.image[data-v-50573ab2] {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.image[data-v-50573ab2] {\n  object-fit: cover;\n  object-position: 50% 50%;\n}"];

export default magicStyles;
